import truncate from "truncate-html";

$(document).ready(function() {
  if ($('.interview-template').length) {

    let limit = 9,
      offset = 9,
      allLoaded = false,
      win = $(window),
      doc = $(document),
      loading = false,
      plusOffset = 500,
      footerHeight = $('.s-footer').height() + $('.s-social').height();


    let msnryGrid = document.querySelector('.masonry-interview-grid');
    let msnry = new window.masonry(msnryGrid, {
      itemSelector: '.masonry__brick',
      percentPosition: true,
      resize: false,
      horizontalOrder: true
    });

    win.scroll(function() {
      let heightOffeset = win.scrollTop() + win.height() + footerHeight + plusOffset;

      if (heightOffeset > doc.height()) {
        if (loading || allLoaded) return;

        loading = true;
        ajaxQuery();
        $('.interviews-loader').css('display', 'block');
      }
    });

    setInterval(function () {
      msnry.layout();
    }, 1500);

    function ajaxQuery() {
      $.ajax({
        url: '/api/publisher-interviews',
        type: 'GET',
        data: {
          limit: limit,
          offset: offset,
        },
        dataType: 'json',
        success: function (interviews) {
          displayInterviews(interviews);

          offset += limit;

          if (interviews.length < limit) {
            allLoaded = true;
          }

          $('.interviews-loader').css('display', 'none');
          setTimeout(function() {
            loading = false;
          }, 1000);
        },
      });
    }

    function displayInterviews(interviews) {
      interviews.forEach(function (interview) {
        let template = $('.interview-template').first().clone();
        template.removeClass('interview-template');

        let allAnswers = interview.interview_answers.reduce((concat, answer) => {
          return concat + answer.text;
        }, '');

        let interLink = '/interviews/' + interview.identificator;
        template.find('.inter-link').attr('href', interLink);
        template.find('.inter-link img').attr('src', interview.imagePath);
        template.find('.inter-link2').attr('href', interLink);
        template.find('.inter-link2 .span1').text(interview.name);
        template.find('.inter-link2 .span2').text(interview.position);
        template.find('.inter-answer').html(truncate(allAnswers, 170));
        template.find('.inter-link3').attr('href', interLink);

        template.css('display', 'block');

        $('.masonry-interview-grid').append(template);
        msnry.appended(template);
        msnry.layout();
      });
    }
  }
});